import logNewRelicCustom from '../../../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../../../constants';

export const getImageWapperClass = ({ selectedCabinet, id }) => {
  if (selectedCabinet?.id === id) {
    return 'image-wrapper--active';
  }
  return 'image-wrapper';
};

export const getCabinetStyle = ({
  left, top, width, height, imageState, mirror, border
}) => {
  const styles = {
    left,
    width,
    height,
    top,
    transform: imageState === 'loaded' ? `scaleX(${mirror ? -1 : 1})` : null,
    border: border ? '2px solid rgb(249 99 2)' : null,
  };
  return styles;
};

export const getSpacerTextStyle = ({ origin, spacerName, mirror }) => {
  if (!origin || !spacerName) return {};
  const styles = {};
  if (origin.Width <= spacerName.length + 4) {
    styles.transform = 'rotate(-90deg)';
    styles.whiteSpace = 'nowrap';
  } else if (mirror) {
    styles.transform = 'scaleX(1)';
  }
  return styles;
};

export const handleImageError = ({
  isSmallWidth, itemId, designId, styleChoiceId, vizImageRoute, setImageState
}) => {
  setImageState(isSmallWidth ? 'smallWidth' : 'failed');
  if (![-1, -2].includes(itemId)) {
    logNewRelicCustom(NEW_RELIC_EVENTS.CABINET_IMAGE_FAILED_LOAD, {
      itemId,
      designId,
      styleChoiceId,
      vizImageRoute
    });
  }
};

export const handleImageLoad = ({ setImageState }) => {
  setImageState('loaded');
};

const selectCabinet = ({ cabinets, id, setSelectedCabinet }) => {
  const selected = cabinets.find((cab) => cab.id === id && cab.Sku !== -3);
  if (selected) {
    setSelectedCabinet(selected);
  }
};

const handleImageClick = ({ event, cabinets, id, setSelectedCabinet }) => {
  event.preventDefault();
  event.stopPropagation();

  selectCabinet({ cabinets, id, setSelectedCabinet });
};

export const handleMouseDown = ({
  event, cabinets, id, setSelectedCabinet, setMouseDownPos
}) => {
  selectCabinet({ cabinets, id, setSelectedCabinet });
  setMouseDownPos({ mouseX: event.clientX, mouseY: event.clientY });
};

export const handleMouseUp = ({
  event, mouseDownPos, setMouseDownPos, cabinets, id, setSelectedCabinet
}) => {
  if (!mouseDownPos) return;
  const dx = Math.abs(event.clientX - mouseDownPos.mouseX);
  const dy = Math.abs(event.clientY - mouseDownPos.mouseY);
  const threshold = 5; // px
  if (dx < threshold && dy < threshold) {
    handleImageClick({ event, cabinets, id, setSelectedCabinet });
  }
  setMouseDownPos(null);
};
